import { styled } from '@mui/material/styles';
import { Field } from '.';

export const StyledField = styled(Field)(({ theme }) => ({
  marginRight: theme.spacing(1.5),
  marginBottom: theme.spacing(1.5),
  width: 200,
}));
